import React, { useState, useEffect, useRef, useContext } from "react";
import axios from "axios";
import Footer from "./Footer";
import { contentContext } from "../context/contentContext";
import { useNavigate } from "react-router-dom";
import Loader from "../components/loader";
import tmdbApi from "../api/tmdbApi";
import SessionPopup from "./SessionPopup";

import { ToastContainer } from "react-toastify";

import { toast } from "react-toastify";

let { lambda, appname } = window.app;

const LL = () => {
    const [data, setData] = useState([]);
    const [tagsPrepared, setTagsPrepared] = useState(false);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [tagCarousels, setTagCarousels] = useState([]);
    const [activeVideo, setActiveVideo] = useState(null);
    const [inputQuery, setInputQuery] = useState('');
    const [query, setQuery] = useState('');
    const [searchField, setSearchField] = useState('title');
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const { GetTimeActivity, isLoading, setIsLoading, } = useContext(contentContext);
    const [selectedTag, setSelectedTag] = useState(-1);
    const [options, setOptions] = useState([]); // dropdown list (label/value)

    const navigate = useNavigate();
    const itemsPerPage = 9;
    const token = localStorage.getItem("token");
    const backTpPrev = () => {
        // if (window.history.length > 2) {
        navigate(-1); // go back
        // } else {
        //     navigate('/'); // or your home route
        // }
    }

    useEffect(() => {
        // if (!localStorage.getItem("token")) {
        //             navigate("/");
        //         }
        //tag api
        getTagAPI();
        getTags();
        window.scrollTo(0, 0);
    }, []);


    const getTagAPI = async () => {
        let result = await tmdbApi.librarytaginfo();

        if (result?.result === "Invalid token or Expired") {
            setShowSessionPopupup(true);
        } else {
            console.log('result?.result?.length', result?.result);
            if (Array.isArray(result?.result) && result.result.length > 0) {
                setTagCarousels([...result.result].sort());
                setTagsPrepared(true);
            } else {
                console.warn('result.result is not an array:', result?.result);
            }
        }
    };

    const getTags = (e) => {
        GetTimeActivity()
        const userId = localStorage.getItem("userId")
        const token = localStorage.getItem("token")
        axios({
            method: 'GET',
            url: lambda + '/tagInfo?appname=' + appname + '&type=videoTag',

            // + '&token=' + token,
        })
            .then(function (response) {
                console.log("response tagsssssssssssss", response?.data?.result);

                const list = response?.data?.result?.map((tag) => tag.name

                );

                console.log('list', list)
                setOptions(list);


            });
    }
    console.log('list', options)
    useEffect(() => {
        fetchLibraryData(query, currentPage);
    }, [query, currentPage]);

    const clearSearch = () => {
        setInputQuery('');
        setQuery('');
        setSelectedTag(null)
        fetchLibraryData('', 1)
    };

    const submitData = () => {
        // ✅ Empty / whitespace-only validation
        if (inputQuery.trim().length === 0) {
            toast.error("Search field cannot be empty.");
            return;
        }

        setCurrentPage(1);
        setQuery(inputQuery);
    };


    const fetchLibraryData = (searchQuery = '', page = 1) => {
        setIsLoading(true)
        setLoading(true);
        const token = localStorage.getItem("token")
        let params = {
            appname,
            assetcount: itemsPerPage,
            pageNumber: page,
            search: searchQuery,
            token: token,
            pageName: "ACTIVE"
        }


        axios
            .get(`${lambda}/lectureLibraryInfo`, {
                params: params
            })
            .then((response) => {
                const result = response?.data?.result;
                if (response?.data?.result === "Invalid token or Expired") {
                    setIsLoading(false)
                    setShowSessionPopupup(true)
                } else if (result?.data && Array.isArray(result.data)) {
                    setData(result.data);

                    let totalPagesTmp = Math.ceil(result.totalCount / itemsPerPage);

                    if (searchQuery) {
                        totalPagesTmp = Math.ceil(result.data.length / itemsPerPage);
                    }
                    setTotalPages(totalPagesTmp);
                    setIsLoading(false)
                } else {
                    setData([]);
                    setTotalPages(0);
                    setIsLoading(false)
                }
            })
            .catch((err) => console.error("API error:", err))
            .finally(() => setIsLoading(false));
    };
    // let tags = [];
    // const prepareTags = (videoData) => {
    //     videoData.forEach(item => {
    //         if (Array.isArray(item.tags)) {
    //             tags = tags.concat(item.tags);
    //         }
    //     });
    //     const latest = [...new Set(tags)];
    //     setTagCarousels(latest);
    // };

    const getYouTubeVideoId = (url) => {
        const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        const match = url?.match(regExp);
        return match && match[7].length === 11 ? match[7] : null;
    };

    const TagCarousel = () => {
        const carouselRef = useRef(null);
        const step = 100;

        const handleNext = () => {
            if (carouselRef.current) {
                carouselRef.current.scrollBy({ left: step, behavior: 'smooth' });
            }
        };

        const handlePrev = () => {
            if (carouselRef.current) {
                carouselRef.current.scrollBy({ left: -step, behavior: 'smooth' });
            }
        };

        return (
            <div className="tag-carousel-wrapper" style={{ display: 'flex', alignItems: 'center' }}>
                <button className="tag-carousel-btn" onClick={handlePrev}>&#8249;</button>
                <div
                    className="tag-carousel"
                    style={{
                        overflowX: 'auto',
                        scrollBehavior: 'smooth',
                        display: 'flex',
                        flexWrap: 'nowrap',
                        gap: '10px',
                        padding: '10px 0',
                        flex: 1
                    }}
                    ref={carouselRef}
                >
                    <div
                        className={selectedTag === -1 ? "tag-active" : "tag"}
                        onClick={() => {
                            setSelectedTag(-1);
                            fetchLibraryData('', 1)
                        }}
                        style={{ cursor: "pointer" }}
                    >
                        All
                    </div>
                    {options.map((itm, idx) => (
                        <div
                            key={idx}
                            className={selectedTag === idx ? "tag-active" : "tag"}
                            onClick={() => {
                                setSelectedTag(idx);
                                fetchLibraryData(itm, 1)
                            }}
                            style={{ cursor: "pointer" }}
                        >
                            {itm}
                        </div>
                    ))}
                </div>
                <button className="tag-carousel-btn" onClick={handleNext}>&#8250;</button>
            </div>
        );
    };
    const handleClick = (item) => {
        console.log('itemmmmmmmmmmmmmmm', item)
        if (item.availability === "free") {
            navigate(`/videoplayer/${item?.lecturelibraryid}`)
        } else if (token && item.availability !== "free") {
            navigate("/subscription")
            localStorage.setItem("libraryId", item?.lecturelibraryid)
        } else {
            navigate("/login")
            localStorage.setItem("libraryId", item?.lecturelibraryid)
        }


    }

    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div className="p-4 video-section-wrapper">
                <div className="row breadcrumb" id="breadcrumb-row">
                    <div className="col-lg-12">
                        <div className="d-flex align-items-center">
                            <div className="flex-grow-1">
                                <h4 className="mb-2 card-title" id="breadcrumb-title">Video Library</h4>
                                <p className="menu-path" id="breadcrumb-path"><span>Learning Hub</span> / <b id="breadcrumb-action">Video Library</b></p>
                            </div>
                            <div>
                                {!token && (<a id="back-button" className="stroke-btn-style create-quiz-btn" onClick={() => backTpPrev()}>back</a>)}

                            </div>
                        </div>
                    </div>
                </div>
                {/* Tags & Search */}
                <div className="row align-items-center mb-4 video-library">
                    <div className="col-lg-8">
                        <TagCarousel />
                    </div>
                    <div className="col-lg-4 user-management video-search-bar">
                        <div className="table-data">
                            <div className="search-box mb-2 d-inline-block" id="search-box">
                                <div className="position-relative">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search videos..."
                                        value={inputQuery}
                                        onChange={e => setInputQuery(e.target.value)}
                                        id="search-input"
                                    />
                                    <button className="fill_btn" onClick={submitData} id="search-btn">
                                        <span className="material-icons search-icon">search</span>
                                    </button>
                                </div>
                                <div className="dataTables_length" id="datatable-length-reset">
                                    <button className="fill_btn" onClick={clearSearch} id="reset-btn">
                                        <span className="material-icons-outlined">sync</span>Reset
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div><div className="text-sm-end" id="text-end"></div>
                </div>


                {/* Video Cards */}
                <div className="mt-3">
                    {isLoading ? <Loader /> : <>
                        <div className="row video-grid">
                            {data.length > 0 ? (
                                data.map((item) => {
                                    const videoId = getYouTubeVideoId(item.youtube);
                                    const link =
                                        item.availability === "free"
                                            ? `/videoplayer/${item?.lecturelibraryid}`
                                            : "/subscription";

                                    return (
                                        <div className="col-lg-3 col-md-6 mb-4" key={item._id}>
                                            <a onClick={() => handleClick(item)} className="text-decoration-none text-dark">
                                                <div className="video-card">
                                                    <img src={`https://img.youtube.com/vi/${videoId}/0.jpg`} alt="Thumbnail" />
                                                    <button className="play-btn">
                                                        <span className="material-symbols-outlined">
                                                            {item.availability !== "free" ? "lock" : "play_arrow"}
                                                        </span>
                                                    </button>
                                                </div>
                                                <div>
                                                    <a className="video-title mt-3">{item?.title}</a>
                                                    <p className="video-para mt-2 mb-0">{item?.description}</p>
                                                    {item?.description?.length > 200 && (
                                                        <div className="video-link mt-0">Read more ...</div>
                                                    )}
                                                    <div className="d-flex justify-content-between">
                                                        <div className="d-flex gap-2 video-stats">
                                                            <span>{item?.time}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    );
                                })
                            ) : (
                                <div className="empty-state-body empty-record"  >
                                    <div className="empty-state__message">
                                        <span className="material-icons">summarize</span>
                                        <p className="form-check font-size-16">No videos found.</p>
                                    </div>
                                </div>
                                // <p className="text-center">No videos found.</p>
                            )}
                        </div>
                    </>}

                </div>

                {/* Pagination */}
                {totalPages > 1 && (
                    <div className="d-flex justify-content-center mt-4">
                        <nav>
                            <ul className="pagination">
                                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                    <button className="page-link" onClick={() => setCurrentPage(prev => prev - 1)}>Prev</button>
                                </li>
                                {[...Array(totalPages)].map((_, index) => (
                                    <li key={index} className={`page-item ${currentPage === index + 1 ? "active" : ""}`}>
                                        <button className="page-link" onClick={() => setCurrentPage(index + 1)}>
                                            {index + 1}
                                        </button>
                                    </li>
                                ))}
                                <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                    <button className="page-link" onClick={() => setCurrentPage(prev => prev + 1)}>Next</button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                )}
                {/* ✅ Toast container should be here */}
                <ToastContainer
                    position="bottom-center"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    pauseOnHover
                    draggable
                />

            </div>
        </>
    );
};

export default LL;